import React from 'react';
import { Button, Card, CardContent, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

interface HouseCollectionEmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

const HouseCollectionEmptyState: React.FC<HouseCollectionEmptyStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
}) => (
  <Card>
    <CardContent sx={{ textAlign: 'center', py: 6 }}>
      <Typography variant="h6" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: actionLabel && onAction ? 2 : 0 }}>
        {description}
      </Typography>
      {actionLabel && onAction && (
        <Button variant="contained" startIcon={<Add />} onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </CardContent>
  </Card>
);

export default HouseCollectionEmptyState;